export default __webpack_public_path__ + "static/media/background-light-3.0ceb11cd.jpg";